import Vue from 'vue'

// Axios
import axios    from 'axios';
import VueAxios from 'vue-axios';
import router   from '../router';

const UNAUTHORIZED_REDIRECT_ROUTE_NAME = 'Login';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

// Add a 401 response interceptor
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error.response.status) {
        // handle error: inform user, go to login, etc
        if (router.currentRoute.name !== UNAUTHORIZED_REDIRECT_ROUTE_NAME) {
            router.push({name: UNAUTHORIZED_REDIRECT_ROUTE_NAME});
        }
    }
    return Promise.reject(error);
});

Vue.use(VueAxios, axios);